import React, { useRef, useState } from "react";
import "./FontComponent.css";
import { useDispatch, useSelector } from "react-redux";
import { RxCross2 } from "react-icons/rx";
import { BiCloudUpload } from "react-icons/bi";
import { toast } from "react-toastify";
import {
  deleteUserFont,
  uploadFontToS3,
} from "../../../../../Redux/actions/projectActions";
import CustomToast, {
  customToatStyle,
} from "../../../../../Components/CustomToast/CustomToast";
import DeleteFontModal from "./DeleteFontModal";
import UploadFontModal from "./UploadFontModal";
import { SX_dashboard_star, SXStarsicon, SX_Stars_Purple_icon, SX_Stars_White_icon } from "../../../../../assets/icons";

const CustomFontUpload = ({ onFontUploaded }) => {
  const dispatch = useDispatch();
  const s3CustomFonts = useSelector(
    (state) => state?.project?.customFonts ?? [],
  );

  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [fontToUpload, setFontToUpload] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [fontToDelete, setFontToDelete] = useState(null);
  const fontUploadRef = useRef(null);

  const handleDeleteFont = async (font) => {
    setIsDeleteModalOpen(false);
    if (!font || !font.key) return;
    await dispatch(deleteUserFont(font));
  };

  const handleFontUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowedExts = ["ttf", "otf", "woff", "woff2"];
    const ext = file.name.split(".").pop().toLowerCase();
    if (!allowedExts.includes(ext)) {
      setUploadError("Unsupported format. Use TTF, OTF, WOFF, or WOFF2.");
      if (fontUploadRef.current) fontUploadRef.current.value = "";
      return;
    }
    setUploadError("");
    setFontToUpload(file);
    setIsUploadModalOpen(true);
  };

  const handleCancelUpload = () => {
    setIsUploadModalOpen(false);
    setFontToUpload(null);
    if (fontUploadRef.current) fontUploadRef.current.value = "";
  };

  const handleConfirmUpload = async (file) => {
    setIsUploadModalOpen(false);
    setIsUploading(true);
    try {
      const result = await dispatch(uploadFontToS3(file));
      if (result?.success) {
        toast(
          <CustomToast title="" content={"Font uploaded successfully !"} />,
          customToatStyle,
        );
        onFontUploaded?.(result.fontFamily);
      } else {
        setUploadError(result?.error || "Upload failed. Please try again.");
      }
    } catch {
      setUploadError("Upload failed. Please try again.");
    }
    setIsUploading(false);
    setFontToUpload(null);
    if (fontUploadRef.current) fontUploadRef.current.value = "";
  };

  return (
    <div className="font-upload-section">

      <div className="font-upload-header">
        <div className="">
          <p className="font-upload-title">Upload Custom Font</p>
          {/* <p className="text-[#c5c5c5] text-xs pt-[3px]">Add your brand fonts to use across the application.</p> */}
        </div>
        <div className="flex">
          <p className="font-upload-hint">TTF · OTF · WOFF · WOFF2</p>
          <span><BiCloudUpload   className="w-[35px] h-[35px] text-[#fff]/70 p-[3px] bg-[#2f2b46]" style={{border:'1px solid #a28fe560', borderRadius:'5px'}}/></span>         
        </div>
      </div>

      <label className={`font-upload-btn${isUploading ? " font-upload-btn--loading" : ""}`}>
        {isUploading ? (
          <><span className="font-upload-spinner" />Loading…</>
        ) : (
          <>
            {/* <svg
              width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /> <polyline points="17 8 12 3 7 8" /> <line x1="12" y1="3" x2="12" y2="15" />
            </svg> */}

            <div className="flex flex-col items-center">
              <BiCloudUpload className="w-[50px] h-[50px] text-[#a28fe5]/60 text-[40px]" />
              <p className="text-center font-lable text-[#ffffff]">Drag and drop font files here or <span className="text-[#a28fe5] border-b border-[#a28fe5] ml-[5px]">Browse</span></p>
              {/* <p className="text-center font-lable text-[#ffffff]">or <span className="text-[#a28fe5] border-b border-[#a28fe5] ml-[5px]">Browse</span></p> */}
            </div>
          </>
        )}
        <input
          ref={fontUploadRef}
          type="file"
          accept=".ttf,.otf,.woff,.woff2"
          onChange={handleFontUpload}
          className="font-upload-input"
          disabled={isUploading}
        />
      </label>

      {uploadError && <p className="font-upload-error">{uploadError}</p>}

      {s3CustomFonts.length > 0 && (
        <div className="font-upload-list">
          {s3CustomFonts.map((font) => (
            <div key={font.fontFamily} className="font-upload-chip">
              <span
                className="font-upload-chip-name"
                style={{ fontFamily: `'${font.fontFamily}'` }}
                title={font.fontFamily}
              >
                {font.fontFamily}
              </span>
              <button
                className="font-upload-chip-remove"
                onClick={(e) => {
                  e.stopPropagation();
                  setFontToDelete(font);
                  setIsDeleteModalOpen(true);
                }}
                title="Delete font"
              >
                <RxCross2 />
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="fontUploadMsgBox" >
        <img  className="w-[35px] h-[35px] bg-[#2f2b46] p-[3px] text-[#fff]" src={SX_Stars_White_icon} alt=""  style={{border:'1px solid #a28fe560', borderRadius:'5px'}}/>
        <p className="ml-[10px]">Custom fonts are stored securely and available for all your projects.</p>
      </div>

      {isDeleteModalOpen && (
        <DeleteFontModal
          setIsDeleteModalOpen={setIsDeleteModalOpen}
          fontToDelete={fontToDelete}
          handleDeleteFont={handleDeleteFont}
        />
      )}

      {isUploadModalOpen && (
        <UploadFontModal
          handleCancelUpload={handleCancelUpload}
          fontToUpload={fontToUpload}
          handleConfirmUpload={handleConfirmUpload}
        />
      )}
    </div>
  );
};

export default CustomFontUpload;
